import type { DataProducts } from "@/Models/MPLP/DataProducts";
import type { products } from "@/Models/MProduct/Products";
import type { MSubCategoryHijaSubcategoryV2 } from "@/Models/MSubCategories/MPLPCategory";
import { formatMX } from "@/Utils/Fomat.price";

export const ListProductBuy = (
  //data: products[],
  data: MSubCategoryHijaSubcategoryV2[],
  category: string,
  subCategory: string
) => {
  if (data && data.length > 0) {
    const mapProductToData = (x: products): DataProducts => ({
      id: x.Id,
      title: x.Name,
      price: x.Price,
      listPrice: formatMX(x.ListPrice),
      salesPrice: formatMX(x.SalesPrice),
      cbvAverageRating: x.CBvAverageRating,
      cratesAndReviews: x.CRatesAndReviews,
      cbvRatingRange: x.CBvRatingRange,
      imagenx: x.ImageGroups?.[0]?.images?.[0]?.link || "",
      titleImagen: x.ImageGroups?.[0]?.images?.[0]?.title || "",
      category: category,
      subCategory: subCategory,
      xDefect: "Electrónica",
      brand: x.Brand,
      salesPriceOrder: x.SalesPrice,
      Default: x.Default,
    });

    const datosFilter = data
      ?.find((w) => w.Id === category)
      ?.SubCategories?.filter(
        (s) =>
          s.Id.includes(subCategory.toLowerCase()) &&
          Array.isArray(s.Products) &&
          s.Products.length > 0
      )
      ?.flatMap((f) => f.Products) ?? [];

    const resultMapper = datosFilter.map(mapProductToData);

    return resultMapper;
  }
  return [];
};
